import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from "../../../components/Box";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Helpers } from "../../../helpers/Helpers";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import { AddConstantResponse } from "../../../models/response/constant/AddConstantResponse";
import { ConstantService } from "../../../services/ConstantService";
import { RootState } from "../../../redux/store";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { GetConstantListResponse } from "../../../models/response/constant/GetConstantListResponse";
import { NeighborhoodService } from "../../../services/NeighborhoodService";
import { GetNeighborhoodByIdResponse } from "../../../models/response/neighborhood/GetNeighborhoodByIdResponse";
import { DeleteCountryResponse } from "../../../models/response/country/DeleteCountryResponse";
import toast from "react-hot-toast";
import PostalCodes, { PostalCodeModel } from "./Components/PostalCodes";
import { CountryService } from "../../../services/CountryService";

const NeighborhoodAdd = () => {
    const auth = useSelector((state: RootState) => state.auth)
    const navigate = useNavigate();
    const pageName = "Genel Tanımlamalar > Semt Tanımları"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const [neighborhoodId, setNeighborhoodId] = useState<string | undefined>(undefined);
    const [shortName, setShortName] = useState('');
    const [longName, setLongName] = useState('');
    const [selectedCountry, setSelectedCountry] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedCounty, setSelectedCounty] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedNeighborhoodParent, setSelectedNeighborhoodParent] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [postalCodes, setPostalCodes] = useState<PostalCodeModel[]>([]);
    const [tempPostalCodeIds, setTempPostalCodeIds] = useState<string[]>([]);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true))

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetNeighborhoodByIdResponse = await NeighborhoodService.getNeighborhoodById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setNeighborhoodId(response.data.neighborhoodId);
                setShortName(response.data.code);
                setLongName(response.data.name);

                if (response.data.countryId) {
                    setSelectedCountry({ label: response.data.countryName, value: response.data.countryId });
                }

                if (response.data.countyId)
                    setSelectedCounty({ label: response.data.countyName, value: response.data.countyId });

                if (response.data.districtId)
                    setSelectedNeighborhoodParent({ label: response.data.districtName, value: response.data.districtId });

                var response2: GetConstantListResponse = await ConstantService.getConstantList('NEIGHBORHOOD_POSTAL_CODE', id);

                if (!response2.isSuccess) {
                    toast.error(response2.message)
                    return;
                }

                setPostalCodes(response2.data.map(function (x) {
                    return {
                        postalCodeId: x.constantId,
                        postalCodeStart: x.value,
                        postalCodeEnd: x.additionalValue1 + '',
                        isSelected: false,
                        isAdded: false
                    }
                }));

                setTempPostalCodeIds(response2.data.map(x => x.constantId));
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const saveNeighborhood = async () => {
        try {
            if (Helpers.isEmpty(shortName))
                toast.error('Kodu alanını doldurunuz!')
            else if (Helpers.isEmpty(longName))
                toast.error('Adı alanını doldurunuz!')
            else if (!selectedCountry)
                toast.error('Ülkesi alanını doldurunuz!')
            else if (!selectedCounty)
                toast.error('Şehri alanını doldurunuz!')
            else if (!selectedNeighborhoodParent)
                toast.error('İlçesi alanını doldurunuz!')
            else {
                dispatch(storeActivityIndicator(true));

                var response: AddConstantResponse = await ConstantService.addConstant(neighborhoodId, 'NEIGHBORHOOD', longName, selectedNeighborhoodParent.value, shortName, undefined, undefined);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                for (var i = 0; i < postalCodes.length; i++) {
                    var postalCode = postalCodes[i];

                    var response2: AddConstantResponse = await ConstantService.addConstant(postalCode.isAdded ? undefined : postalCode.postalCodeId, 'NEIGHBORHOOD_POSTAL_CODE', postalCode.postalCodeStart, response.data.constantId, postalCode.postalCodeEnd, undefined, undefined);

                    if (!response2.isSuccess) {
                        toast.error(response2.message)
                        return;
                    }
                }

                var difference = tempPostalCodeIds.filter(x => !postalCodes.map(x => x.postalCodeId).includes(x));

                if (difference && difference.length > 0) {
                    var response3: DeleteCountryResponse = await ConstantService.deleteConstant(difference);

                    if (!response3.isSuccess) {
                        toast.error(response3.message)
                        dispatch(storeActivityIndicator(false))
                        return;
                    }
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <KTCard className="ebbe-card">
                        <KTCardBody>
                            <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                            <div className='row'>
                                <div className="col-md-4">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Kodu</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={shortName} onChange={(e) => setShortName(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Şehri</label>
                                        <CustomSingleSelect
                                            selectedValue={selectedCounty}
                                            onChange={(selectedItem) => {
                                                setSelectedCounty(selectedItem);
                                                setSelectedNeighborhoodParent(undefined);
                                            }}
                                            onMenuOpen={selectedCountry ? () => ConstantService.getConstantList('COUNTY', selectedCountry.value) : undefined}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    {/* Semt ilcenin altinda durur; liste secili ilceye bagli gelir. */}
                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">İlçesi</label>
                                        <CustomSingleSelect
                                            selectedValue={selectedNeighborhoodParent}
                                            onChange={setSelectedNeighborhoodParent}
                                            onMenuOpen={selectedCounty ? () => ConstantService.getConstantList('DISTRICT', selectedCounty.value) : undefined}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Adı</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={longName} onChange={(e) => setLongName(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Ülkesi</label>
                                        <CustomSingleSelect
                                            selectedValue={selectedCountry}
                                            onChange={(selectedItem) => {
                                                setSelectedCountry(selectedItem);
                                                setSelectedCounty(undefined);
                                                setSelectedNeighborhoodParent(undefined);
                                            }}
                                            onMenuOpen={() => CountryService.getCountryList()}
                                            labelName='name'
                                            valueName='countryId'
                                        />
                                    </div>
                                </div>
                            </div>
                        </KTCardBody>
                    </KTCard>

                    <PostalCodes
                        postalCodes={postalCodes}
                        setPostalCodes={setPostalCodes}
                    />

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveNeighborhood}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default NeighborhoodAdd;